interface PostCodeByStateMap {
  [key: string]: string | undefined;
}

export const POST_CODE_BY_STATE: PostCodeByStateMap = {
  NSW: '2000',
  ACT: '2600',
  VIC: '3000',
  QLD: '4000',
  SA: '5000',
  WA: '6000',
  TAS: '7000',
  NT: '0800',
};
